import React from 'react';
import StatisticsCard from '../../../pages/user-profile-dashboard/components/StatisticsCard';

const StatisticsGrid = ({ statistics, safeTrendValue }) => {
  return (
    <div className="hidden sm:grid grid-cols-2 lg:grid-cols-5 gap-2 sm:gap-3 md:gap-6">
      <StatisticsCard
        icon="FolderOpen"
        label="전체 목표"
        value={statistics?.totalProjects}
        trend="neutral"
        trendValue={safeTrendValue?.projects}
        color="primary"
      />
      <StatisticsCard
        icon="CheckCircle"
        label="완료한 챌린지"
        value={statistics?.completedChallenges}
        trend="neutral"
        trendValue={safeTrendValue?.challenges}
        color="success"
      />
      <StatisticsCard
        icon="Image"
        label="제출한 증명"
        value={statistics?.submittedProofs}
        trend="neutral"
        trendValue={safeTrendValue?.proofs}
        color="accent"
      />
      <StatisticsCard
        icon="Star"
        label="평균 별점"
        value={statistics?.averageStars}
        trend="neutral"
        trendValue={safeTrendValue?.avg}
        color="warning"
      />
      <StatisticsCard
        icon="Heart"
        label="받은 좋아요"
        value={statistics?.receivedLikes}
        trend="neutral"
        trendValue="0"
        color="accent"
      />
    </div>
  );
};

export default StatisticsGrid;
